import { styled } from 'parkdepot-shared/theme'

export const Container = styled<'a', { disabled?: boolean }>('a', ({ $theme, disabled = false }) => ({
    textDecoration: 'none',
    color: 'inherit',
    backgroundColor: '#F6F6F6',
    display: 'flex',
    borderRadius: '1.4rem',
    margin: '0.8rem 0',
    cursor: disabled ? 'not-allowed' : 'pointer',

    [$theme.mediaQuery.large]: {
        marginTop: '2.4rem'
    }
}))

export const DataContainer = styled('div', () => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#F6F6F6',
    borderRadius: '1.4rem',
    marginLeft: '1.6rem'
}))

export const DisabledText = styled<'figcaption', { disabled?: boolean }>('figcaption', ({ $theme }) => ({
    position: 'absolute',
    fontSize: '8px',
    lineHeight: '16px',
    fontWeight: 700,
    top: '1rem',
    left: 0,
    right: 0,
    margin: 'auto',
    maxWidth: '10rem',
    backgroundColor: $theme.colors.primary,
    padding: '6px 0',
    textAlign: 'center',
    borderRadius: '3rem',
    color: $theme.colors.white,

    [$theme.mediaQuery.large]: {
        left: '5px',
        right: '5px',
        margin: 'unset',
        maxWidth: 'unset'
    }
}))

export const LotAddress = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 300,
    margin: 0,
    fontStyle: 'normal'
}))

export const LotImage = styled<'img', { disabled?: boolean; $small?: boolean }>(
    'img',
    ({ $theme, disabled = false, $small = false }) => ({
        width: '11rem',
        maxWidth: '11rem',
        minHeight: '12rem',
        height: '100%',
        borderTopLeftRadius: '1.6rem',
        borderBottomLeftRadius: '1.6rem',
        objectFit: 'cover',
        opacity: disabled ? 0.2 : 1,

        [$theme.mediaQuery.large]: {
            ...($small
                ? {
                      width: '11rem'
                  }
                : {
                      width: '16rem',
                      height: '12rem',
                      maxWidth: '16rem'
                  })
        }
    })
)

export const LotImageContainer = styled('figure', () => ({
    position: 'relative',
    margin: 0
}))

export const LotTitle = styled('h3', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 600,
    margin: 0
}))

export const LoadingAnimationStyle = ($isMobile: boolean, smallImage: boolean) => ({
    width: $isMobile || smallImage ? '11rem' : '16rem',
    height: '12rem',
    transform: 'scale(0.5)',
    transformOrigin: 'center'
})
